import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppComponent } from './crypttp.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [],
  exports: [AppComponent]
})
export class Crypttp { }
